export const defaultExpireDays = 365;

export function getLocalStorageOrCookie(name) {
    return localStorage.getItem(name) ?? getCookie(name);
}

export function setLocalStorageAndCookie(name, value, cookieExpiresIn) {
    if (!cookieExpiresIn) {
        cookieExpiresIn = defaultExpireDays;
    }

    try {
        localStorage.setItem(name, value);
    }
    catch (e) {
        console.error("Error setting localStorage item:", e);
    }
    setCookie(name, value, cookieExpiresIn)
}

export function removeLocalStorageAndCookie(name) {
    try {
        localStorage.removeItem(name);
    }
    catch (e) {
        console.error("Error removing localStorage item:", e);
    }
    
    removeCookie(name);
}

function getCookie(name) {
    var value = "; " + decodeURIComponent(document.cookie);
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

function setCookie(name, value, expiresIn) {
    var currentDate = new Date();
    currentDate.setTime(currentDate.getTime() + (expiresIn * 24 * 60 * 60 * 1000));
    var expiresIn = "expires=" + currentDate.toUTCString();
    document.cookie = name + "=" + value + ";" + expiresIn + ";path=/";
}

function removeCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}